import 'bootstrap-slider'

let $ = jQuery

export class RangeSlider {

	$range_slider = null
	$input_slider = null
	$input_from = null
	$input_to = null
	slider = null

	constructor($range_slider) {
		this.$range_slider = $range_slider;
		this.$input_slider = $range_slider.find('.range-slider__slider input')
		this.$input_from = $range_slider.find('input[name="price_from"]')
		this.$input_to = $range_slider.find('input[name="price_to"]')

		// Init
		this.init_slider()
	}

	init_slider() {
		this.$input_slider.slider()

		// Bind change
		this.$input_slider.gp_on('change', this.slider_on_change)
		this.$input_from.gp_on('change', this.inputs_on_change)
		this.$input_to.gp_on('change', this.inputs_on_change)
	}

	get_values() {
		return this.$input_slider.slider('getValue')
	}

	slider_on_change = (e) => {
		let values = this.get_values()
		this.set_values(values[0], values[1])
	}

	inputs_on_change = (e) => {
		this.set_values(this.$input_from.val(), this.$input_to.val())
	}

	set_values(from, to) {

		let from_value = parseFloat(from),
			to_value = parseFloat(to)

		// Don't update when invalid input
		if (isNaN(from_value) || isNaN(to_value)) {
			return
		}

		if (from_value > to_value) {
			to_value = from_value + 1
		}

		// Update inputs
		this.$input_from.val(from_value)
		this.$input_to.val(to_value)

		// Update label values
		this.$range_slider.find('.range-slider__input--from .range-slider__label-value').text(from_value)
		this.$range_slider.find('.range-slider__input--to .range-slider__label-value').text(to_value)

		// Update range slider
		this.$input_slider.slider('setValue', [from_value, to_value]);
	}

	reset_from_value() {
		this.set_values(this.$input_slider.data('slider-min'), this.get_values()[1])
	}

	reset_to_value() {
		this.set_values(this.get_values()[0], this.$input_slider.data('slider-max'))
	}

	reset_values() {
		this.$input_slider.slider('refresh')
	}

}

$(document).gp_ready(function () {
	$('.range-slider').each(function () {
		new RangeSlider($(this))
	})
})
